import { render, staticRenderFns } from "./infoResult.vue?vue&type=template&id=7c347548&scoped=true"
import script from "./infoResult.vue?vue&type=script&lang=js"
export * from "./infoResult.vue?vue&type=script&lang=js"
import style0 from "./infoResult.vue?vue&type=style&index=0&id=7c347548&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c347548",
  null
  
)

export default component.exports